import * as React from 'react';

const Van16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.265 4H13.5a2 2 0 0 1 1.984 1.752l.5 4.5A2 2 0 0 1 14 12.5h-.235a2.5 2.5 0 0 1-5 0H6.5A2.5 2.5 0 0 1 4 15c-1.387 0-2.533-1.177-2.5-2.563A2 2 0 0 1 0 10.5V3a2 2 0 0 1 2-2h7.265a2 2 0 0 1 2 2zM6 11h3.265q.214-.286.5-.5V3a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v7.5a.5.5 0 0 0 .5.5c.456-.607 1.182-1 2-1s1.544.393 2 1m7.265 0H14a.5.5 0 0 0 .496-.562l-.18-1.938h-3.05V10a2.5 2.5 0 0 1 2 1ZM3 12.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m7.265 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1-5.5h2.864l-.133-1.062A.5.5 0 0 0 13.5 5.5h-2.235z"
  }
));
Van16.Size = 16;
Van16.Title = "Van";

export { Van16 as default };
